import _ from 'lodash'
import swal from 'sweetalert2'
/* eslint-disable */
export default {
    mergeObjectWithMaster(objectMaster, objectSlave) {
        let objectResult = {}
        for (let pMaster in objectMaster) {
            if (!_.isUndefined(objectSlave[pMaster])) {
                objectResult[pMaster] = objectSlave[pMaster]
            } else {
                objectResult[pMaster] = objectMaster[pMaster]
            }
        }
        return objectResult
    },
    confirm(message, callbackSuccess, callbackError) {
        swal({
            title: 'Confirmation',
            text: message,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continuer',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            if (result.value) {
                if (_.isFunction(callbackSuccess)) {
                    callbackSuccess()
                }
            } else {
                if (_.isFunction(callbackError)) {
                    callbackError()
                }
            }
        })
    },
    reportShareAlert (text) {
        swal({
            type: 'info',
            html: `
                <input type="text" 
                class="form-control input-text-for-report-share" 
                onload="this.select()"
                value="${text}"/>
            `,
            showCloseButton: false,
            showCancelButton: true,
            showConfirmButton: false,
            focusConfirm: false,
            confirmButtonAriaLabel: 'Thumbs up, great!',
            cancelButtonText:
                'Fermer',
            cancelButtonAriaLabel: 'Thumbs down',
        })
    }

}